import { render, staticRenderFns } from "./ShowProjectTimeline.vue?vue&type=template&id=0206072b&scoped=true&"
import script from "./ShowProjectTimeline.vue?vue&type=script&lang=js&"
export * from "./ShowProjectTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ShowProjectTimeline.vue?vue&type=style&index=0&id=0206072b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206072b",
  null
  
)

export default component.exports